import { DiscordForm } from '@modules/integrations/components/DiscordIntegration/DiscordForm';
import { EditIntegrationIncompleteWarningAlert } from '@modules/integrationsV2/components/EditIntegrationDrawerContent/EditIntegrationIncompleteWarningAlert';
import { useUpdateIntegration } from '@modules/integrationsV2/hooks';
import { EditIntegrationDrawerContentProps } from '@modules/integrationsV2/types';
import { trackEditIntegrationEvent } from '@modules/integrationsV2/utils';
import { Box } from '@mui/material';
import { DiscordChannelInput, IntegrationChannelType } from 'generated/graphql';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { AddOrEditIntegrationDrawerHeader } from '../../AddOrEditIntegrationDrawerHeader';

export const EditDiscordIntegrationDrawerContent = ({
  onDrawerClose,
  integrationID,
  integrationData,
  integrationType,
}: EditIntegrationDrawerContentProps) => {
  const [updateIntegration, { status: updateIntegrationStatus }] =
    useUpdateIntegration({
      channelType: IntegrationChannelType.Discord,
      integrationType,
      onCompleted: () => {
        onDrawerClose();
        trackEditIntegrationEvent({
          eventName: 'Edit Integration Submitted',
          channelType: IntegrationChannelType.Discord,
          integrationID,
        });
      },
    });

  const updateChannels = (selectedChannels: DiscordChannelInput[]) => {
    updateIntegration({
      integrationID,
      isActive: true,
      updateData: {
        discord: {
          subscribedChannels: selectedChannels,
        },
      },
    });
  };

  const isLoading = IsLoading(updateIntegrationStatus);

  return (
    <>
      <AddOrEditIntegrationDrawerHeader title="Edit Discord Integration" />
      <Box p={3}>
        <EditIntegrationIncompleteWarningAlert
          integrationData={integrationData}
          channelType={IntegrationChannelType.Discord}
        />
        <DiscordForm
          integrationID={integrationID}
          onSubmit={updateChannels}
          integrationData={integrationData}
          isLoading={isLoading}
        />
      </Box>
    </>
  );
};
